/**
 * Flash Message Handler
 * Dismisses server-rendered flash messages on click and after a timeout,
 * using the `.animate-out` CSS animation defined in global.css.
 */

(() => {
  const AUTO_DISMISS_MS = 6000;
  const ANIMATION_MS = 500;

  function dismiss(el) {
    if (!el || el.dataset.dismissing === 'true') return;
    el.dataset.dismissing = 'true';
    el.classList.add('animate-out');
    setTimeout(() => {
      el.remove();
      // Remove the wrapping .alert if it has no more messages.
      document.querySelectorAll('.flash-messages .alert').forEach((alert) => {
        if (!alert.querySelector('p')) alert.remove();
      });
      const container = document.querySelector('.flash-messages');
      if (container && !container.querySelector('p')) container.remove();
    }, ANIMATION_MS);
  }

  function init() {
    const messages = document.querySelectorAll('.flash-messages .alert p');
    messages.forEach((msg, index) => {
      msg.addEventListener('click', () => dismiss(msg));
      // Stagger auto-dismiss slightly so multiple alerts animate in sequence.
      setTimeout(() => dismiss(msg), AUTO_DISMISS_MS + index * 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
